import { useState } from "react"
import { ConnStatus } from "../../Helpers"
import { useActions, useAppState } from "../../overmind"


const StreamStatus = () => {
    const status = useAppState((state) => state.connectionStatus)
    const isLoggedIn = useAppState((state) => state.isLoggedIn)
    const reconnect = useActions().global.startSubmissionStream
    const [open, setOpen] = useState<boolean>(false)

    if (!isLoggedIn) {
        // Don't show stream status if not logged in
        return null
    }

    const handleMouseEnter = () => {
        setOpen(true)
    }

    const handleMouseLeave = () => {
        setOpen(false)
    }

    const handleOnClick = () => {
        // Attempt to reconnect
        reconnect()
    }

    const streamStarter = open ? <i className="fas fa-repeat fa-stack-1x " onMouseLeave={handleMouseLeave} onClick={handleOnClick} /> : null

    // Show stream status based on connection status
    switch (status) {
        case ConnStatus.CONNECTED:
            return <i className="fas fa-circle text-success" title="Connected" />
        case ConnStatus.RECONNECTING:
            return (
                <span className="fa-stack fa-lg2">
                    <i className="fas fa-circle fa-stack-1x text-warning" title="Attempting to re-establish stream connection" onMouseEnter={handleMouseEnter} />
                    {streamStarter}
                </span>
            )
        default:
            return (
                <span className="fa-stack">
                    <i className="fas fa-circle fa-stack-1x text-danger" title="No stream connection" onMouseEnter={handleMouseEnter} />
                    {streamStarter}
                </span>
            )
    }
}

export default StreamStatus
